import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import moment from 'moment';
import { ConfirmationService } from 'primeng/api';
import { PainelinsumoService } from '../../../services/painelinsumo.service';
import { ToastService } from '../../../services/toast.service';
import { EstoqueErpOS } from '../../../types/EstoqueErpOS.type';
import { InsumoConsumidoOS } from '../../../types/InsumoConsumidoOS.type';
import { OrdemInsumo } from '../../../types/OrdemInsumo.type';
import { OrdemInsumoItems } from '../../../types/OrdemInsumoItems.type';
import { Remessa } from '../../../types/Remessa.type';

@Component({
  selector: 'app-detalhes',
  templateUrl: './detalhes.component.html',
  styleUrl: './detalhes.component.css',
  providers: [ConfirmationService],
})
export class DetalhesComponent implements OnInit{

  ordem!: OrdemInsumo;
  itens!: OrdemInsumoItems;

  remessas: Remessa[] = [];

  selectedItems!: OrdemInsumoItems[];

  insumosConsumidos: InsumoConsumidoOS[] = []
  insConsumidos:  { [s: string]: Number } = {};

  loadingEstoqueERP: boolean = false;
  estoqueErp: EstoqueErpOS[] = [];
  estoqueMaterialErp: { [s: string]: Number } = {};

  abreAtendimento: boolean = false;
  remessaSelecionada!: Remessa;

  constructor(private painelService: PainelinsumoService, private toastService: ToastService, private activatedRoute: ActivatedRoute, private confirmationService: ConfirmationService){}

  ngOnInit(){
    this.carregarOrdem();
  }


  carregarOrdem(){
    let id = this.activatedRoute.snapshot.paramMap.get('id');

    if(id){
      this.painelService.getOrdem(id).subscribe({
        next: (data) => {
          this.ordem = data;

          this.getInsumosBaixado(this.ordem.instancia, this.ordem.noOs, "");
          this.getRemessas();
          this.getEstoqueErp()
        },
        error: (error) => {
          this.toastService.erro("Erro", "Erro ao buscar: " + error.message)
          console.log(error)
        },
        complete: () => {

        }
      })
    }
  }

  getEstoqueErp(){
    this.loadingEstoqueERP = true;

    this.painelService.getEstoqueErp(this.ordem.id).subscribe({
      next: (data) => {
        this.estoqueErp = data

        data.forEach((e) => {
          this.estoqueMaterialErp[e.material] = e.quantidade
        })

      },
      error: (error) => {
        this.toastService.erro("Erro ao consultar saldo", error.error.message)
      },
      complete: () => {
        this.loadingEstoqueERP = false;
      }
    })
  }

  formatDate(data: string){
    return moment(data).format("DD/MM/yyyy");
  }

  getInsumosBaixado(instancia: string, os: string, insumo: string){
    this.painelService.getInsumosBaixados(instancia, os, insumo).subscribe({
      next: (value) => {
        this.insumosConsumidos = value;

        this.insumosConsumidos.forEach((x) => {
          this.insConsumidos[x.cdInsumo] = x.quantidade
        })
      },
      error: (error) => {
        console.error(error)
      },
      complete: () => {

      }
    })
  }

  getRemessas(){

    this.painelService.getRemessas(this.ordem.id).subscribe({
      next: (data) => {
        this.remessas = data
      },
      error: (error) => {
        console.log(error.error.message)
      },
      complete: () => {
        console.log("Finalizado")
      }
    })
  }

  getBaixado(insumo: string){

    return Number(this.insConsumidos[insumo]) || 0

  }

  getDescricaoTipo(tipo: string){
    let txt = ""
    switch(tipo){
      case "T":
        txt = "Entre OS";
        break;
      case "R":
        txt = "Retirada";
        break;
      case "D":
        txt = "Devolução";
        break;
      case "M":
        txt = "Virtual";
        break;
    }

    return txt;
  }

  getStatusReserva(tipo: string){
    let txt = ""
    switch(tipo){
      case "NA":
        txt = "Não Atendido"
        break;
      case "AT":
        txt = "Atendido";
        break;
      case "ER":
        txt = "Erro";
        break;
      case "CA":
        txt = "Cancelada";
        break;
      case "AP":
        txt = "Parcial";
        break;
    }

    return txt;
  }

  getStatusReservaSeverity(tipo: string){
    let txt = ""
    switch(tipo){
      case "NA":
        txt = ""
        break;
      case "AT":
        txt = "success";
        break;
      case "ER":
        txt = "danger";
        break;
      case "CA":
          txt = "info";
          break;
      case "AP":
        txt = ""
    }

    return txt;
  }

  getStyleTable(){
    return "{backgroundColor:'var(--highlight-bg)', color: 'var(--highlight-text-color)', borderRadius: 'var(--border-radius)'}";
  }

  abreAtendimentoDialog(remessa: Remessa) {

    this.remessaSelecionada = remessa;

    this.abreAtendimento = true;
  }

  escondeAtendimentoDialog() {
    this.abreAtendimento = false;

    this.carregarOrdem();
  }

  cancelarRemessa(event: Event, remessa: Remessa) {

    let usuario = localStorage.getItem("cdUsuarioErp") || ""

    this.confirmationService.confirm({
      target: event.target as EventTarget,
      message: 'Tem certeza que deseja cancelar a remessa?',
      header: 'Confirmar',
      icon: 'pi pi-exclamation-triangle',
      acceptIcon:"none",
      rejectIcon:"none",
      rejectButtonStyleClass:"p-button-text",
      acceptLabel: "Sim",
      rejectLabel: "Não",
      accept: () => {
        this.painelService.postCancelarRemessa(remessa.id, usuario).subscribe({
          next: (value) => {
             this.toastService.sucesso("Sucesso","Cancelamento realizado");
          },
          error: (error) => {
            this.toastService.erro("Erro",error);
          },
          complete: () => {
            this.getRemessas();
          }
        })
      },
    });

  }

  statusOrdem(fgStatus: string) {

    let retorno = "";
    switch(fgStatus){
      case "F":
        retorno = "Fechada";
        break;
      case "E":
        retorno = "Excluída";
        break;
      case "A":
        retorno = "Aberta";
    }

    return retorno;
  }

  realizaMovimentao(fgStatus: string){
    return fgStatus != "A";
  }
}
